<template>
    <div class="recommend-box">
        <mc-button
            v-if="!skuLabelList.length"
            type="primary"
            class="btn-demo-item"
            size="small"
            :loading="loading"
            @click="getSkuLabelRecommend"
        >
            AI推荐搜索词
        </mc-button>
        <div
            v-else
            class="ai-recommend"
        >
            <div class="recommend-title">
                AI推荐搜索词
            </div>
            <div class="tag-box">
                <template v-if="!loading">
                    <mc-tag
                        v-for="(item, index) in skuLabelList"
                        :key="index"
                        @click="handleTag(item)"
                    >
                        {{ item }}
                    </mc-tag>
                </template>
            </div>
            <div class="footer-btn">
                <mc-button
                    type="primary"
                    class="btn-demo-item"
                    size="small"
                    :loading="loading"
                    @click="getSkuLabelRecommend"
                >
                    重新生成
                </mc-button>
            </div>
        </div>
    </div>
</template>
<script>
import {
    defineComponent,
    ref,
    watch,
    computed,
} from '@vue/composition-api';
import { hPost } from '@mcfe/tools';

export default defineComponent({
    name: 'AiSearchKeyWord',
    props: {
        value: {
            type: [String, Array],
            default: () => ([]),
        },
        skuName: {
            type: String,
            default: '',
        },
        bgCategoryId: {
            type: [Number, String],
            default: null,
        },
        bgCategoryList: {
            type: Array,
            default: () => ([]),
        },
        /**
         * 可区分页面来源：
         * - mode有值：申请编辑页
         * - mode无值：新建品页
         */
        mode: {
            type: String,
            default: '',
        },
    },
    setup(props, { emit, root }) {
        const { $message } = root;

        const loading = ref(false);

        const isCreateFirst = ref(!props.mode);
        const skuLabelList = ref([]);

        const skuSearchTermsValue = computed(() => {
            const { value } = props;
            if (Array.isArray(value) && value.length) {
                return value;
            } else if (typeof value === 'string' && value.length) {
                return value.split(',');
            } else {
                return [];
            }
        });

        const getSkuLabelRecommend = async () => {
            const { skuName, bgCategoryId, bgCategoryList } = props;
            if (!skuName) {
                $message.warning('请输入商品名称');
                return;
            }
            if (!bgCategoryId) {
                $message.warning('请选择后台类目');
                return;
            }

            loading.value = true;
            const bgCategoryName = bgCategoryList.find((item) => item.categoryId === bgCategoryId)?.categoryLabel || '';

            const params = {
                skuName,
                extensions: {
                    bgCategoryName,
                },
            };

            // 获取算法推荐结果
            try {
                const res = await hPost('/api/vss/shepherd/ProductAlgToolTService/skuSearchRecommend', params);
                skuLabelList.value = res?.skuLabels || [];
                if (!res?.skuLabels?.length) {
                    $message.warning('算法推荐结果为空, 请修改商品名称后重试');
                }
            } catch (error) {
                skuLabelList.value = [];
                console.warn('ERROR_获取推荐搜索词失败', error);
            } finally {
                loading.value = false;
            }
        };

        const handleTag = (item) => {
            const uniqueValues = Array.from(new Set([...skuSearchTermsValue.value, item])); // 去重
            emit('save', uniqueValues);
        };


        // 添加监听器并支持清除
        const stopWatch = watch(
            () => [props.skuName, props.bgCategoryId],
            ([newSkuName, newBgCategoryId]) => {
                if (newSkuName && newBgCategoryId && isCreateFirst.value) {
                    isCreateFirst.value = false;
                    getSkuLabelRecommend();
                    // 停止监听
                    stopWatch();
                }
            },
        );

        return {
            skuLabelList,
            getSkuLabelRecommend,
            handleTag,
            loading,
        };
    },
});
</script>
<style lang="scss" scoped>
.recommend-box {
    width: 100%;
}
.ai-recommend {
    border: 1px solid #D6D9DF;
    padding: 10px;
    .recommend-title {
        font-size: 16px;
        font-weight: bolder;
        color: #111925;
    }
    .tag-box {
        padding: 10px 0;
    }
    .footer-btn {
        text-align: right;
    }
}
.mtd-tag {
    margin-right: 8px;
    cursor: pointer;
}
</style>
